import React from 'react';
import ChartDatasetSettings from '../../settings_sidebar/ChartDatasetSettings.jsx';

function SimplePieDatasetWidgetSettings({ widgetId }) {

    return (
        <ChartDatasetSettings widgetId={widgetId} 
            chart_settings_props={{
                additional_settings: ["number_format", "display_labels_on_data", "dataset_type"],
                chart_type: 'pie',
                display_labels_on_data_options: ["without_labels", "with_labels"],
                dataset_type_options: ["single", "grouped"]
            }}
        />
    )
}

export default SimplePieDatasetWidgetSettings;
